import React, { useState } from "react";
import { Modal, Button } from 'react-bootstrap';

import './modal.css';

const YesNoModal = (props) => {
    const [show, setShow] = useState(props.show || true);

    const handleNo = () => {
        setShow(false);
        props.onNo && props.onNo();
    }

    const handleYes = () => {
        setShow(true);
        props.onYes && props.onYes();
    }

    const { title, message } = props;

    return (
        <Modal className='clsYesNoModal' show={show} onHide={ handleNo }>
            <Modal.Header>
                <Modal.Title className='clsModal_title warn'>{ title }</Modal.Title>
            </Modal.Header>
            <Modal.Body>{ message }</Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={ handleNo }>
                    NO
                </Button>
                <Button variant="primary" onClick={ handleYes }>
                    YES
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default YesNoModal;